<template>
    <div v-if="socials.length > 0" class="socials">
        <a
            v-for="(social, index) in socials"
            :key="index"
            :href="social.url"
            target="_blank"
            rel="noopener noreferrer"
            class="social-link bg-slblue"
        >
            <i
                v-if="$validateText(social.icon)"
                class="social-icon fa-lg"
                :class="social.icon"
            />
            
        </a>
    </div>
</template>

<script>
export default {
    props: {
        authorDocument: {
            type: Object,
            required: true
        }
    },
    computed: {
        socials() {
            const socialData = this.authorDocument.data;
            return [
                {
                    url: this.$validateText(socialData.email) 
                        ? `mailto:${socialData.email}` 
                        : null,
                    icon: 'fa-solid fa-envelope'
                },
                {
                    url: socialData.linkedin_url,
                    icon: 'fa-brands fa-linkedin'
                },
            ].filter(social => this.$validateText(social.url));
        }
    }
};
</script>

<style lang="scss" scoped>
.socials {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;
    @include font-size(14px);
    .social-link {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        text-decoration: none;
        color: $font;
        border-radius: 100px;
        width: fit-content;
        transition: ease-in-out 0.15s;
        width: 40px;
        height: 40px;
        &:hover {
            color: $green;
        }
    }
}
</style>
